module.exports = __webpack_public_path__ + "static/media/phila_tiger.b3c8e313.webp";